import { lazy } from 'react';

export default [
  {
    path: `${config.urls.baseUrl}/off_time`,
    label: 'OffTime',
    component: lazy(() => import('./pages/OffTime/OffTime' /*webpackChunkName: "OffTime"*/)),
  },
  {
    path: `${config.urls.baseUrl}/new_client`,
    label: 'AddNewClient',
    exact: true,
    component: lazy(() => import('./pages/AddNewClient/AddNewClient' /*webpackChunkName: "AddNewClient"*/)),
  },
  {
    path: `${config.urls.baseUrl}/choosing_client`,
    label: 'ChoosingClient',
    exact: true,
    component: lazy(() => import('./pages/ChoosingClient/ChoosingClient' /*webpackChunkName: "ChoosingClient"*/)),
  },
  {
    path: `${config.urls.baseUrl}/choosing_worker`,
    label: 'ChoosingWorker',
    exact: true,
    component: lazy(() => import('./pages/ChoosingWorker/ChoosingWorker' /*webpackChunkName: "ChoosingWorker"*/)),
  },
  {
    path: `${config.urls.baseUrl}/selecting_procedure`,
    label: 'SelectingProcedure',
    exact: true,
    component: lazy(() => import('./pages/SelectingProcedure/SelectingProcedure' /*webpackChunkName: "SelectingProcedure"*/)),
  },
  {
    path: `${config.urls.baseUrl}/selecting_time`,
    label: 'SelectingTime',
    exact: true,
    component: lazy(() => import('./pages/SelectingTime/SelectingTime' /*webpackChunkName: "SelectingTime"*/)),
  },
  {
    path: `${config.urls.baseUrl}/summary`,
    label: 'Summary',
    exact: true,
    component: lazy(() => import('./pages/Summary/Summary' /*webpackChunkName: "Summary"*/)),
  },
  {
    path: `${config.urls.baseUrl}/booked_successfully`,
    label: 'AppointmentBookedSuccessfully',
    exact: true,
    component: lazy(() =>
      import(
        './pages/AppointmentBookedSuccessfully/AppointmentBookedSuccessfully' /*webpackChunkName: "AppointmentBookedSuccessfully"*/
      ),
    ),
  },
  {
    path: `${config.urls.baseUrl}/:date`,
    label: 'Calendar',
    exact: true,
    component: lazy(() => import('./pages/Calendar/Calendar' /*webpackChunkName: "Calendar"*/)),
  },
  {
    path: `${config.urls.baseUrl}/appointments/:date/appointment_id/:event_id`,
    label: 'EventPage',
    exact: true,
    component: lazy(() => import('./pages/EventPage/EventPage' /*webpackChunkName: "EventPage"*/)),
  },
];
